import { core } from '@tock/coretypes';
import { lowerCase } from 'es-toolkit/compat';

interface PurchaseDetailsWithDispute {
  dispute?: core.PaymentDispute | core.IPaymentDispute | null;
}

export function isDisputed(purchaseDetails: PurchaseDetailsWithDispute): boolean {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return !!purchaseDetails.dispute && lowerCase(purchaseDetails.dispute.status!) !== 'won';
}
